<template>
  <v-container>
    <v-row class="ma-0">
      <v-col cols="12"><h2>Botões</h2></v-col>

      <v-col>
        <v-btn class="primary-button">primary-buton</v-btn>
      </v-col>
      <v-col>
        <v-btn class="secondary-button">secondary-buton</v-btn>
      </v-col>
      <v-col>
        <v-btn class="primary-ghost-button">primary-ghost-buton</v-btn>
      </v-col>
      <v-col>
        <v-btn class="secondary-ghost-button">secondary-ghost-buton</v-btn>
      </v-col>
      <v-col cols="12"><h2>Inputs</h2></v-col>
      <v-col>
        <v-text-field
          class="primary-input"
          outlined
          placeholder="primary-input"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          class="secondary-input"
          outlined
          placeholder="secondary-input"
        ></v-text-field>
      </v-col>
      <v-col cols="12"><h2>Textos</h2></v-col>
      <v-col>
        <span class="label">label</span>
      </v-col>
      <v-col>
        <span class="label-bold">label-bold</span>
      </v-col>
      <v-col>
        <span class="label-with-color">label-with-color</span>
      </v-col>
      <v-col>
        <span class="main-title">main-title</span>
      </v-col>
      <v-col>
        <span class="main-description">main-description</span>
      </v-col>
      <v-col>
        <span class="navigation-title">navigation-title</span>
      </v-col>
      <v-col>
        <span class="navigation-description">navigation-description</span>
      </v-col>
      <v-col>
        <span class="navigation-item">navigation-item</span>
      </v-col>
      <v-col>
        <span class="tab-label">tab-label</span>
      </v-col>
      <v-col>
        <span class="tab-active-label">tab-active-label</span>
      </v-col>
      <v-col>
        <span class="label-bold-grey">label-bold-grey</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "guide",
};
</script>

<style scoped>
</style>